// type : either use scenarios or wizardtypes
// id: either use scenario key or wizard type id ( the id defined in the config editor )

define(function(require) {
    var IpsModel = require('civicsBase/ipsModel');
    return IpsModel.extend({
        urlRoot: '/delegate/civics-api/api/portal/{0}/{1}/wizards/{2}',
        url:function(){
          if ( this.isNew()  )
    			   return this.urlRoot.format(this.type,this.typeId,'');
          else {
            return this.urlRoot.format(this.type,this.typeId,this.id);
          }
    		}
    });
});
